'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  staging: {
    isProduction: true
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  nonSecureHost: process.env.NON_SECURE_HOST || 'localhost',
  port: process.env.PORT,
  baseUrl: process.env.BASE_URL || '//localhost/franco-exhumacion-entierro',
  project: process.env.BASE_URL || 'franco-exhumacion-entierro',
  projectName: 'franco-exhumacion-entierro',
  app: {
    title: 'franco-exhumacion-entierro',
    description: 'franco-exhumacion-entierro.',
    head: require('./metadata.json')
  },
  urlTraduction: {
    'home': 'home'
  }
}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 72
// module chunks = 0